import PageTitle from '@/components/Admin/PageTitle';
import React from 'react';
import styled from 'styled-components';
import { useQuery } from '@tanstack/react-query';
import { colors } from '@/constants/colors';
import { useUIStore } from '@/store/useUIStore';
import { fetchPayout } from '@/api/payout';
import Table from '@/components/Admin/Table';

interface TablePayout {
   _id: string;
   createdAt: string;
   accountNumber: string;
   payoutAccount: string;
   status: 'processing' | 'settled' | 'cancelled';
   amount: number;
   netAmount: number;
   disbursementFee: number;
   payoutMethod: 'string';
}

type PageTitleActions = {
   type: 'normal' | 'button';
   title: string;
   onClick?: () => void;
};

const Payout = () => {
   const { refresh, handleShow, handleRefresh, handleClose } = useUIStore();
   const {
      data: response,
      isLoading,
      error,
   } = useQuery({
      queryKey: ['payout-list', refresh],
      queryFn: fetchPayout,
   });

   // console.log(`---response`, response?.data.result);

   const transformedData =
      response?.data?.result?.map((item: TablePayout) => ({
         ...item,
         createdAt: item.createdAt || '-',
         accountNumber: String(item.accountNumber) || '-',
         payoutAccount: item.payoutAccount || '-',
         status: item.status || '-',
         amount: item.amount || 0,
         netAmount: item.netAmount || 0,
         disbursementFee: item.disbursementFee || 0,
         payoutMethod: item.payoutMethod || '-',

         // subscription: billing.subscription || 0,
         // status: billing.status || 0,
         // amount: billing.amount || 0,
      })) || [];

   // console.log(`----transformedData`, transformedData);

   const payoutHeadData = [
      {
         type: 'title',
         value: 'Date',
      },
      {
         type: 'title',
         value: 'Name',
      },
      {
         type: 'title',
         value: 'Account #',
      },
      {
         type: 'title',
         value: 'Status',
      },
      {
         type: 'title',
         value: 'Amount',
      },
      {
         type: 'title',
         value: 'Net Amount',
      },
      {
         type: 'title',
         value: 'Disbursement Fee',
      },
      {
         type: 'title',
         value: 'Bank',
      },
      {
         type: 'title',
         value: 'Action',
      },
   ];

   const pageTitleActions: PageTitleActions[] = [];

   const dropdownData = [
      // {
      //    type: 'normal',
      //    value: 'View',
      //    icon: 'check-circle-line',
      //    label: 'Proceed',
      //    onClick: (item: TablePayout) => {
      //       console.log(item);
      //       // window.open(item.checkoutUrl, '_blank');
      //    },
      // },
      {
         type: 'normal',
         value: 'Cancel',
         icon: 'close-line',
         label: 'Cancel',
         onClick: (item: TablePayout) => {
            console.log(item);
            // cancelBilling(item._id)
            //    .then(() => {
            //       toast.success('Billing cancelled successfully');
            //       handleRefresh();
            //    })
            //    .catch((err) => {
            //       console.log(err);
            //    });
         },
      },
   ];

   return (
      <Wrapper>
         <PageTitle title="Payout" actions={[]} />

         {isLoading ? (
            <LoadingText>Loading records...</LoadingText>
         ) : error ? (
            <ErrorText>Error loading records: {error.message}</ErrorText>
         ) : (
            <Table<TablePayout>
               headData={payoutHeadData}
               data={transformedData}
               grid={`1fr 1fr 200px 100px 100px 100px 120px 50px auto`}
               type="payout"
               dropdownData={dropdownData}
            />
         )}
      </Wrapper>
   );
};

const Wrapper = styled.div``;
const LoadingText = styled.div`
   text-align: center;
   padding: 2rem;
   color: ${colors.GRAY5};
`;

const ErrorText = styled.div`
   text-align: center;
   padding: 2rem;
   color: ${colors.DANGER};
`;
export default Payout;
